import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

/**
 * Sets the page title in the gov.cy DSF format
 * `Page title - Service Name - gov.cy` and the meta description.
 * Pass i18n keys (not raw strings) — output stays reactive to locale changes.
 * @see https://gov-cy.github.io/govcy-design-system-docs/getting-started/page-template/
 * @param {string} titleKey - i18n key for the page title.
 * @param {string} [descriptionKey] - i18n key for the page description. Optional.
 */
export const usePageHead = (titleKey, descriptionKey) => {
  const { t } = useI18n()

  const meta = []
  if (descriptionKey) {
    meta.push({
      name: 'description',
      content: computed(() => t(descriptionKey)),
    })
  }

  useHead({
    title: computed(() => `${t(titleKey)} - ${t('common.service_name')} - gov.cy`),
    meta,
  })
}
